import { getToken } from './authService';

const BACKEND = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API_URL = `${BACKEND}/api/shanthi`;

function authHeaders(extra = {}) {
  const t = getToken();
  const h = { ...extra };
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
}

async function handleResponse(res) {
  if (res.status === 204) return null;
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      detail = body.detail || JSON.stringify(body);
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

/**
 * Send a message to Shanthi and get her response.
 *
 * @param {string} message - The user's message
 * @param {string|null} threadId - Existing thread ID for conversation continuity
 * @returns {Promise<{reply: string, thread_id: string, activity_saved: object|null, steps: Array<{name: string, args: object, result: any}>}>}
 */
export async function sendMessage(message, threadId = null) {
  const res = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ message, thread_id: threadId }),
  });
  return handleResponse(res);
}

/** List all threads for the signed-in user (most recent first). */
export async function listThreads() {
  const res = await fetch(`${API_URL}/threads`, {
    method: 'GET',
    headers: authHeaders(),
  });
  return handleResponse(res);
}

/** Fetch the full message history for one thread. */
export async function getThreadMessages(threadId) {
  const res = await fetch(`${API_URL}/threads/${encodeURIComponent(threadId)}/messages`, {
    method: 'GET',
    headers: authHeaders(),
  });
  return handleResponse(res);
}

/** Delete a thread and all its messages. */
export async function deleteThread(threadId) {
  const res = await fetch(`${API_URL}/threads/${encodeURIComponent(threadId)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  return handleResponse(res);
}
